// Lightweight session persistence via localStorage. Only stores lightweight
// text state (not raw image blobs longer than necessary) and gracefully
// swallows quota errors.

const KEY = "dogstyle_ai_session_v1";
const MAX_PREVIEWS_PER_SESSION = 3;

export function loadSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveSession(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // Quota exceeded — silently ignore, the app still works in-memory.
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export { MAX_PREVIEWS_PER_SESSION };
